import React from "react";
import "./css/AboutUs.css";
import headerBg from "./assets/picOne.png"; // reuse or replace with a relevant image

const CertificationFirms = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Certification Firms</h1>
          <p className="subtitle">
            The Malawi Bureau of Standards (MBS) collaborates with accredited certification firms under its Industrial Research and Training division to ensure effective and reliable certification services.
          </p>
          <p className="subtitle">
            These firms play a key role in auditing, evaluating, and certifying organizations, products, and personnel in line with national and international standards.
          </p>
        </div>
      </section>

      {/* === Roles of Certification Firms Section === */}
      <section className="intro-section">
        <h2 className="section-title">Roles of Certification Firms</h2>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Conduct audits and assessments of management systems and processes</li>
              <li>Evaluate compliance with national and international standards</li>
              <li>Provide recommendations for corrective actions and improvements</li>
              <li>Support accreditation and certification processes</li>
              <li>Ensure impartiality and objectivity in all certification activities</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Conduct surveillance and follow-up audits for certified organizations</li>
              <li>Provide technical consultancy and guidance for quality improvement</li>
              <li>Facilitate training and capacity building for client organizations</li>
              <li>Maintain proper documentation and records of certification activities</li>
              <li>Enhance the credibility and recognition of certified entities</li>
            </ul>
          </div>
        </div>
      </section>

      {/* === Benefits Section === */}
      <section className="functions-section">
        <h2 className="section-title">Benefits of Working with Certification Firms</h2>
        <p>
          Collaboration with MBS-accredited certification firms ensures professional, impartial, and credible certification services. 
          Organizations benefit from enhanced compliance, improved quality, market recognition, and confidence among stakeholders.
        </p>
      </section>

      {/* === Contact Section === */}
      <section className="functions-section">
        <h2 className="section-title">Contact for Certification Firms</h2>
        <p>
          For inquiries or information regarding MBS-accredited certification firms, please contact the Industrial Research and Training Certification team.
        </p>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Email: <a href="mailto:certification@mbs.mw">certification@mbs.mw</a></li>
              <li>Phone: +265 (0) 1 789 777</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Office: Malawi Bureau of Standards, P.O. Box 946, Blantyre, Malawi</li>
              <li>Website: <a href="https://www.mbs.mw">www.mbs.mw</a></li>
            </ul>
          </div>
        </div>
        <p className="subtitle">
          MBS-accredited certification firms ensure that organizations, products, and personnel meet required standards, promoting quality, safety, and competitiveness in Malawi.
        </p>
      </section>

      <br /><br />
    </div>
  );
};

export default CertificationFirms;
